
<button type="button" class="btn btn-sm" (click)="editEvent.emit()" >
  <i class="glyphicon glyphicon-pencil"></i>
</button>
@if (showDeleteB) {
  <app-smart-button onHttpCall="disable" showSpinner="true" buttonClasses="btn btn-sm btn-danger" (click)="deleteEvent.emit()">
    <i class="glyphicon glyphicon-trash"></i>
  </app-smart-button>
}
